enum authScope {
  OPEN_ID = 'openid',
  PROFILE = 'profile',
  OFFLINE_ACCESS = 'offline_access',
}

export const authScopesDefault: string[] = [authScope.OPEN_ID, authScope.PROFILE, authScope.OFFLINE_ACCESS];
